import { createContext, useContext } from "react";
import { DEFAULT_PAGE } from "./constants";
import { IProductListState } from "./types";

const initialState: IProductListState = {
  loading: true,
  page: DEFAULT_PAGE
};

const ProductsContext = createContext<IProductListState>(initialState);

const useProductsContext = () => useContext(ProductsContext);

export { ProductsContext, useProductsContext };
